
import moment, { Duration, Moment } from "moment";
import { ErrorMessage, Field, Form } from "vee-validate";
import { defineComponent, ref, computed, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import objectPath from "object-path";
import { Actions } from "../../../../store/enums/StoreEnums";
import * as Yup from "yup";

export default defineComponent({
  components: {
    ErrorMessage,
    Field,
    Form,
  },
  setup() {
    const loading = ref<boolean>(false);
    const store = useStore();
    const router = useRouter();
    const verificationCode = ref<string>("");
    const emailVerificationSchema = Yup.object().shape({
      verificationCode: Yup.string().required().label("Verification Code"),
    });
    const timeExists = ref<boolean>(false);
    const verificationSendTime = ref<string | null>("");
    const verficationCodeLimit = ref<string | null>("");
    const interval = ref<number>(0);
    const timeLeft = ref<string>("");
    const timedOut = ref<boolean>(false);
    const op = computed(() => {
      return objectPath;
    });
    const user = computed(() => {
      return store.getters.getUser;
    });
    const resendCode = async () => {
      try {
        const response = await store.dispatch(Actions.RESEND_VERIFY_CODE);
        if (response.status !== 200) throw new Error();
        store.commit("setAlert", {
          message: "Success",
          subMessage: "Verification Code Resent!",
          variant: "primary",
          duration: 4000,
          show: true,
        });
        clearInterval(interval.value);
        localStorage.setItem(
          "verification_code_time",
          objectPath.get(response, "data.data.sendTime", "")
        );
        localStorage.setItem(
          "verification_code_limit",
          objectPath.get(response, "data.data.timeLimit", "")
        );
        verificationSendTime.value =
          localStorage.getItem("verification_code_time") ?? "10:20:00";
        verficationCodeLimit.value = localStorage.getItem(
          "verification_code_limit"
        );
        timeExists.value = false;
        timedOut.value = false;
        verificationCodeTime();
      } catch (err) {
        const error = store.getters.getErrors;
        store.commit("setAlert", {
          message: "Error",
          subMessage: error,
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    const verify = async (values) => {
      loading.value = true;
      try {
        const response = await store.dispatch(Actions.VERIFY_AUTH, {
          code: values.verificationCode,
        });
        if (response[0] !== true) throw new Error();
        loading.value = false;
        store.commit("setAlert", {
          message: "Success",
          subMessage: "Verification Successful!",
          variant: "primary",
          duration: 4000,
          show: true,
        });
        await store.dispatch(Actions.AUTH_USER);
        nextTick(() => {
          router.push("/add-role");
        });
      } catch (err) {
        loading.value = false;
        const error = store.getters.getErrors;

        store.commit("setAlert", {
          message: "Error",
          subMessage: error,
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    const verificationCodeTime = () => {
      let time1 = "";
      let time2 = "";
      if (timeExists.value) {
        if (typeof verficationCodeLimit.value === "string") {
          time1 =
            verficationCodeLimit.value.split(":")[0] ??
            verficationCodeLimit.value;
          time2 = verficationCodeLimit.value.split(":")[1] ?? "00";
        }
      }
      let sendTime = verificationSendTime.value ?? "";
      let hours: number = parseInt(sendTime.split(":")[0]);
      let minutes: number = parseInt(sendTime?.split(":")[1]);
      let seconds: number = parseInt(sendTime?.split(":")[2]);
      let now = moment().set({
        hour: hours,
        minutes: minutes,
        seconds: seconds,
      });
      let then: Moment;
      if (timeExists.value) {
        then = moment()
          .set({ hour: hours, minutes: minutes, seconds: seconds })
          .add(time1, "minutes")
          .add(time2, "seconds");
      } else {
        then = moment()
          .set({ hour: hours, minutes: minutes, seconds: seconds })
          .add(verficationCodeLimit.value, "minutes");
      }
      if (timeExists.value) {
        clearInterval(interval.value);
      }
      interval.value = setInterval(() => {
        now = now.add("1", "second");
        let duration: Duration = moment.duration(then.diff(now));
        timeLeft.value =
          duration.minutes() +
          ":" +
          (duration.seconds() < 10
            ? `0${duration.seconds()}`
            : duration.seconds());
        localStorage.setItem(`verification_code_limit`, timeLeft.value);
        if (duration.minutes() == 0 && duration.seconds() == 0) {
          clearInterval(interval.value);
          timedOut.value = true;
        }
      }, 1000);
    };
    onMounted(() => {
      if (localStorage.getItem("verification_code_time") !== null) {
        timeExists.value = true;
      }
      verificationSendTime.value =
        localStorage.getItem("verification_code_time") ?? "10:20:00";
      verficationCodeLimit.value = localStorage.getItem(
        "verification_code_limit"
      );
      verificationCodeTime();
    });
    return {
      loading,
      verificationCode,
      emailVerificationSchema,
      verify,
      user,
      op,
      timedOut,
      timeLeft,
      resendCode,
    };
  },
});
